"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapVehicleInputToFaunaCreateInput = exports.mapSingleVehicleInputToFaunaCreateInput = void 0;
const mappers_1 = require("../../utils/mappers");
const mapSingleVehicleInputToFaunaCreateInput = (input) => {
    const mappedVehicle = mappers_1.FaunaMapper.mapFaunaInput(input);
    return Object.assign(Object.assign({}, mappedVehicle), { model: (mappedVehicle === null || mappedVehicle === void 0 ? void 0 : mappedVehicle.model) ? { create: mappedVehicle.model } : undefined, reference: (mappedVehicle === null || mappedVehicle === void 0 ? void 0 : mappedVehicle.reference) ? { create: mappedVehicle.reference } : undefined, vehicleLine: (mappedVehicle === null || mappedVehicle === void 0 ? void 0 : mappedVehicle.vehicleLine) ? { create: mappedVehicle.vehicleLine } : undefined, orderFromFactoryDetails: (mappedVehicle === null || mappedVehicle === void 0 ? void 0 : mappedVehicle.orderFromFactoryDetails)
            ? { create: mappedVehicle.orderFromFactoryDetails }
            : undefined });
};
exports.mapSingleVehicleInputToFaunaCreateInput = mapSingleVehicleInputToFaunaCreateInput;
const mapVehicleInputToFaunaCreateInput = (input) => {
    return Array.isArray(input) && input.length > 0
        ? {
            create: input.map(exports.mapSingleVehicleInputToFaunaCreateInput),
        }
        : undefined;
};
exports.mapVehicleInputToFaunaCreateInput = mapVehicleInputToFaunaCreateInput;
//# sourceMappingURL=vehicle.js.map